module.exports = __webpack_public_path__ + "img/气质类型测试.56c04f8b.png";